import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';
import { useAuth } from '../../context/AuthContext';

const TABS = [
  { path: '/acquisti', label: 'Prezzario' },
  { path: '/acquisti/dashboard', label: 'Dashboard' },
  { path: '/acquisti/fornitori', label: 'Fornitori' },
  { path: '/acquisti/personale', label: 'Personale' },
  { path: '/acquisti/costi-fissi', label: 'Costi fissi' },
  { path: '/acquisti/bancari', label: 'Bancari' },
  { path: '/acquisti/documenti', label: 'Fatture' },
  { path: '/acquisti/carica', label: 'Carica', adminOnly: true },
];

/** Header sticky + sotto-navigazione della sezione Acquisti e Costi. */
export const AcquistiHeader = ({ titolo, sottotitolo, azione, largo = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isAdmin = user?.ruolo === 'admin' || user?.is_super_admin;
  const tabs = TABS.filter((t) => !t.adminOnly || isAdmin);

  return (
    <header className="glass-header sticky top-0 z-40 border-b border-border">
      <div className={cn('mx-auto px-4 pt-4 pb-2', largo ? 'max-w-lg lg:max-w-[1600px] lg:px-6' : 'max-w-lg')}>
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate('/')} data-testid="acquisti-back-btn">
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div className="min-w-0 flex-1">
            <h1 className="text-xl font-bold font-heading tracking-tight truncate">{titolo}</h1>
            {sottotitolo && <p className="text-xs text-muted-foreground truncate">{sottotitolo}</p>}
          </div>
          {azione}
        </div>

        <nav className="mt-3 -mx-1 flex gap-1 overflow-x-auto pb-1">
          {tabs.map((t) => {
            const active = location.pathname === t.path;
            return (
              <button
                key={t.path}
                onClick={() => navigate(t.path)}
                data-testid={`acquisti-tab-${t.label.toLowerCase()}`}
                className={cn(
                  'shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide transition-colors',
                  active
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-secondary text-muted-foreground hover:text-foreground'
                )}
              >
                {t.label}
              </button>
            );
          })}
        </nav>
      </div>
    </header>
  );
};

export default AcquistiHeader;
